export const screenWidth = 772;